export default __webpack_public_path__ + "static/media/dyp.7bba42d9.png";